import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import SpaceDashboard from './SpaceDashboard';
import SpaceDocument from './SpaceDocument';
import SpaceMaterial from './SpaceMaterial';
import SpaceProject from './SpaceProject';

export default function Service() {
  const { path } = useRouteMatch();
  console.log(path);
  return (
    <Switch>
      <Route exact path={`${path}/space-project`} component={SpaceProject} />
      <Route exact path={`${path}/space-document`} component={SpaceDocument} />
      <Route exact path={`${path}/space-material`} component={SpaceMaterial} />
      <Route
        exact
        path={`${path}/space-dashboard`}
        component={SpaceDashboard}
      />
      <Route exact path="*" component={() => <Redirect to="/error/404" />} />
    </Switch>
  );
}
